<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="" />
      <div class="detail_txt">
        <div class="title">
          医疗健康分析平台
        </div>
        <div class="txt">
          Informatization Products
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div>
        <div class="txt">
          <!-- <p>基于物联网的变电站挂接地线管理装置的研发成果，由国网上海市电力公司市北供电公司于2021年2月在钱湾站内进行了安装应用试验。</p> -->
          <p>
            项目针对上海市电力医院的需求，通过基于大数据的诊疗方法，不仅可以提高医生诊疗的准确度，同时基于大数据的诊疗过程通过
            图表直观的显示在大数据诊断展示模块的显示屏上，医生可以直观看到结果的推断过程，更加直观；并且风险预测发送模块也可以提早
            对用户患病风险进行预测。本项目充分利用业务中台支撑服务，新建设基于多源数据融合的电力企业职工健康状态的大数据分析及预测
            中心管控模块，进一步提电力职工健康管理能力。
          </p>
        </div>
      </div>
      <div>
        <div class="title">软件应用图示：</div>
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/dev1 (1).png" alt="" />
            <div class="txt">
              图一：用户可自由选择公司和任意三年时间跨度来自动生成一份团检报告。包含对特定人群的筛选、分类、专业医生的指导与建议，AI智能分析的结果与建议。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/dev1 (2).png" alt="" />
            <div class="txt">
              图二：用户可自由选择单位、年龄段、性别、异常情况名称进行特定人群的划分，平台会根据用户划定的特定人群进行健康分析。
            </div>
          </div>
        </div>
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/dev1 (3).png" alt="" />
            <div class="txt">
              图三：用户可选择多家单位、多个异常情况查看在某一年中各个单位在所选几个异常情况中的检出率比较。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/dev1 (4).png" alt="" />
            <div class="txt">
              图四：用户在选定单位和时间可查看此单位三年健康数据的多样化大数据看板，此看板将多种图表类型进行组合，在不同的角度查看团体健康数据，结合用户自身需求来进行大数据可视化页面的展示。
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from "../router/index.js";
export default {
  methods: {
    gotoHome() {
      router.push("/");
    }
  }
};
</script>
<style scoped>
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;
  height: 600px;
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px;
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 480px;
  height: 350px;
}
/* .img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .img2 {
  width: 320px;
  height: 490px;
} */
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}

.detail_foot {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail11.vue